import { Reveal, Overline } from "@/components/public/Reveal";
import Seo from "@/components/Seo";

export default function MentionsLegales() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <Seo title="Mentions légales" path="/mentions-legales" description="Mentions légales du site Acanthe Jardins." />
      <article className="max-w-3xl mx-auto px-6 md:px-12">
        <Overline>Informations légales</Overline>
        <h1 className="mt-3 font-display text-4xl lg:text-5xl text-forest">Mentions légales</h1>
        <div className="mt-10 prose-acanthe" data-testid="mentions-legales">
          <h2>Éditeur du site</h2>
          <p>
            Le site <strong>acanthejardins.fr</strong> est édité par la société <strong>Acanthe Jardins</strong>,
            SARL au capital de 5 000 €, spécialisée dans l'aménagement et l'entretien des espaces extérieurs.<br />
            Adresse : 665 Avenue du Raumartin, 13730 Saint-Victoret, France<br />
            Téléphone : 04 42 69 02 13 — Mobile : 06 34 58 63 33<br />
            Email : contact@acanthejardins.fr<br />
            SIRET : 752 676 825 00017 — TVA intracommunautaire : FR79 752676825 — Code APE : 8130Z
          </p>

          <h2>Hébergement</h2>
          <p>Le site est hébergé sur une infrastructure cloud sécurisée. Les coordonnées de l'hébergeur sont disponibles sur simple demande auprès de l'éditeur.</p>

          <h2>Conception & réalisation</h2>
          <p>Site internet et application conçus et réalisés par <a href="https://besson-solutions.fr" target="_blank" rel="noopener noreferrer">Besson-Solutions.fr</a>.</p>

          <h2>Propriété intellectuelle</h2>
          <p>L'ensemble des contenus présents sur ce site (textes, images, logo, réalisations, éléments graphiques) est la propriété exclusive d'Acanthe Jardins ou de ses partenaires, sauf mention contraire. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite et constitue une contrefaçon sanctionnée par le Code de la propriété intellectuelle.</p>

          <h2>Responsabilité</h2>
          <p>Acanthe Jardins s'efforce d'assurer l'exactitude des informations diffusées sur ce site mais ne saurait être tenue responsable des erreurs, omissions ou d'une indisponibilité temporaire du service. Les informations sont fournies à titre indicatif et sont susceptibles d'évoluer.</p>

          <h2>Liens hypertextes</h2>
          <p>Le site peut contenir des liens vers des sites tiers. Acanthe Jardins n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.</p>

          <h2>Droit applicable</h2>
          <p>Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
        </div>
      </article>
    </div>
  );
}
